import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const { getBookedSlots } = importer('APIs/appointments', null)
const AppointmentsActions = importer('Stores/Appointments/Actions')
const { tokens } = importer('Stores/Users/Select', null)
export default function * main ({
  pdn,
  limit,
  appointmentType
}) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`
    yield put(AppointmentsActions.getBookedSlotsLoading())
    const res = yield getBookedSlots(
      pdn,
      limit,
      appointmentType,
      token
    )
    yield put(AppointmentsActions.getBookedSlotsSuccess(res, token))
  } catch (error) {
    yield put(AppointmentsActions.getBookedSlotsFailure(error))
  }
}
